import { FC } from 'react';
import { useLanguage } from '../i18n/useLanguage';
import type { Language } from '../i18n/language';
import { legalContact } from '../content/legalContent';
import { localizeSiteModeMessage } from '../hooks/useSiteMode';

type SiteMode = 'coming_soon' | 'maintenance';

interface SiteModeScreenProps {
  mode: SiteMode;
  message?: string | null;
}

const copy: Record<Language, Record<SiteMode, { title: string; subtitle: string; contact: string }>> = {
  tr: {
    coming_soon: {
      title: 'Çok Yakında Buradayız',
      subtitle: 'Foliano: English by Levels mobil deneyimi hazırlanıyor.',
      contact: 'Bize Ulaşın',
    },
    maintenance: {
      title: 'Bakım Modu',
      subtitle: 'Kısa bir bakım yapıyoruz. Birazdan tekrar buradayız.',
      contact: 'Bize Ulaşın',
    },
  },
  en: {
    coming_soon: {
      title: 'Coming Soon',
      subtitle: 'Foliano: English by Levels mobile experience is being prepared.',
      contact: 'Contact Us',
    },
    maintenance: {
      title: 'Maintenance Mode',
      subtitle: 'We are doing a short maintenance. We will be back shortly.',
      contact: 'Contact Us',
    },
  },
};

const SiteModeScreen: FC<SiteModeScreenProps> = ({ mode, message }) => {
  const { language } = useLanguage();
  const content = copy[language][mode];
  const localizedMessage = localizeSiteModeMessage(message, language);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-800 via-primary-600 to-primary-500 text-white">
      <div className="container-custom flex min-h-screen items-center justify-center">
        <div className="w-full max-w-2xl text-center">
          <p className="mx-auto inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1 text-xs uppercase tracking-[0.2em]">
            Foliano: English by Levels
          </p>
          <h1 className="mt-6 text-4xl font-bold md:text-5xl">{content.title}</h1>
          <p className="mt-4 text-lg text-white/90">{content.subtitle}</p>
          {localizedMessage && (
            <div className="mt-6 rounded-2xl bg-white/10 px-6 py-4 text-sm text-white/90">
              {localizedMessage}
            </div>
          )}
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href={`mailto:${legalContact.supportEmail}`}
              className="btn btn-primary bg-white text-primary-700 hover:bg-white/90"
            >
              {content.contact}
            </a>
            <span className="rounded-full border border-white/30 px-4 py-2 text-xs uppercase tracking-[0.2em] text-white/80">
              App Store &amp; Google Play
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteModeScreen;
